module.exports = __webpack_public_path__ + "static/img/3-7.fcb0cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-7.jpg
// module id = gA6C
// module chunks = 1